<template>
	<div>
		<trainSearch title="培训报名" :isSearch="true"></trainSearch>
		<div class="container">
			<div style="display: flex;flex-direction: column;height: 3.75rem;margin: 0 2rem">
				<div  @click="selectedItem=999"   :class="selectedItem==999?'selectedItem profileHover':'profileHover'" style="cursor: pointer; background-color: #FFFFFF; border-radius: 0.25rem;width:240px;
				height: 54px;font-size: 1rem;padding: 0.9375rem;margin-bottom:0.3125rem;">
							全部
						</div>
				<div v-for="(item,index) in OfflineTrainingsTypeData" @click="selectedItem=item.offlineTrainingTypeId" :class="selectedItem==item.offlineTrainingTypeId?'selectedItem profileHover':'profileHover'" style="cursor: pointer; background-color: #FFFFFF; border-radius: 0.25rem;width: 240px;
		height: 54px;font-size: 1rem;padding: 0.9375rem;margin: 0.3125rem 0;">
					{{item.title}}
				</div>
				<!-- <div @click="selectedItem=2" :class="selectedItem==2?'selectedItem profileHover':'profileHover'" style="cursor: pointer;background-color: #FFFFFF; border-radius: 0.25rem;width: 17.8125rem;
		height: 3.75rem;font-size: 1rem;padding: 0.9375rem;margin: 0.3125rem 0;">
					入室安全培训
				</div>
				<div @click="selectedItem=3" :class="selectedItem==3?'selectedItem profileHover':'profileHover'" style="cursor: pointer;background-color: #FFFFFF; border-radius: 0.25rem;width: 17.8125rem;
		height: 3.75rem;font-size: 1rem;padding: 0.9375rem;margin: 0.3125rem 0;">
					专项技术培训
				</div> -->
			</div>
			<div style="width: 892px;">
					<!-- <div style="background-color: white;" v-if="selectedItem==1&&OfflineData.length==0">
						<a-result  title="暂无数据">
						   
						  </a-result>
					</div>
					<div style="background-color: white;" v-else-if="selectedItem==2&&safetyTrainData.length==0">
						<a-result  title="暂无数据">
						   
						  </a-result>
					</div>
					<div style="background-color: white;" v-else-if="selectedItem==3&&specialTrainData.length==0">
						<a-result  title="暂无数据">
						   
						  </a-result>
					</div> -->
				<signCard   v-show="selectedItem==999" :ids="'空白'"></signCard>
				<signCard   v-show="selectedItem==item.offlineTrainingTypeId" :ids="item.offlineTrainingTypeId" :data="item"  v-for="(item,i) in OfflineTrainingsTypeData"></signCard>
				<!-- <signCard    :key="i+'2'" v-show="selectedItem==2" :total='safetyTrainData.totalCount'  :ids="'5'"   :data="item" v-for="(item,i) in safetyTrainData" ></signCard>
				<signCard    :key="i+'3'" v-show="selectedItem==3" :total='specialTrainData.totalCount'  :ids="'6'"  :data="item" v-for="(item,i) in specialTrainData"></signCard> -->
			</div>
			
			
		</div>

	</div>
</template>

<script>
	import {OfflineTrainings,OfflineTrainingsType} from '@/api/index.js'
	import trainSearch from '../../components/trainSearch.vue'
	import signCard from '../../components/signCard.vue'
	export default {
		name:'/trainSign',
		components: {
			trainSearch,
			signCard
		},
		data() {
			return {
				OfflineTrainingsTypeData:[],
				OfflineData:[],
				safetyTrainData:[],
				specialTrainData:[].
				OfflineTrainings,
				selectedItem: 999,
				signData: [{
						ifRegular: 1,
						title: '云讲堂第一讲：ImageJ 实用教程：免疫荧光定量分析(Peter博后分享)',
						trainDate: '每周二、周五',
						nextDate: '12月第4期  2021-12-14（周二） 09:00-11:00',
						nextLocation: '综合楼1003会议室',
						regularTimes: '20/30'
					},
					{
						ifRegular: 0,
						title: 'dddddddddddddd',
						trainDate: '每周二、周五',
						nextDate: '12月第4期  2021-12-14（周二） 09:00-11:00',
						nextLocation: '综合楼1003会议室',
						regularTimes: '20/30'
					},
					{
						ifRegular: 1,
						title: 'sssssssssssssssssssssssss',
						trainDate: '每周二、周五',
						nextDate: '12月第4期  2021-12-14（周二） 09:00-11:00',
						nextLocation: '综合楼1003会议室',
						regularTimes: '20/30'
					}
				]
			}
		},
		created() {
			this.getAllTrain(5)
			OfflineTrainingsType().then((res)=>{
				this.OfflineTrainingsTypeData = res.data.data
				console.log(res.data.data)
			})
		},
		methods:{
			getAllTrain(row){
				this.getOfflineData({OfflineTrainingTypeId: 1,page: 1,row: row ,name:window.localStorage.getItem('searchValues'),})
				this.getOfflineData({OfflineTrainingTypeId: 5,page: 1,row: row ,name:window.localStorage.getItem('searchValues'),})
				this.getOfflineData({OfflineTrainingTypeId: 6,page: 1,row: row,name:window.localStorage.getItem('searchValues'),})
			},
			async getOfflineData(data){
				let OfflineData = await OfflineTrainings(data)
				if(data.OfflineTrainingTypeId==1){
						this.OfflineData= OfflineData.data.data
						this.OfflineData.totalCount = OfflineData.data.totalCount
				}
				else if(data.OfflineTrainingTypeId==5){
					this.safetyTrainData=OfflineData.data.data
					this.safetyTrainData.totalCount = OfflineData.data.totalCount
				}
				else if(data.OfflineTrainingTypeId==6){
					this.specialTrainData=OfflineData.data.data
					this.specialTrainData.totalCount = OfflineData.data.totalCount
				}
			}
		}
	}
</script>

<style scoped>
	.container {
		width: 100%;
		display: flex;
		background-color: #F6F8FA;
		height: 100%;
		min-height: 37.5rem;
		justify-content: center;
		padding-top: 3.75rem;
		padding-bottom: 4.6875rem;
		position: relative;

	}
	.selectedItem {
		background: #1890FF !important;
		color: white;
	}
</style>
